(($, Drupal) => {
  const id = "xencms:paragraph--prices";

  Drupal.behaviors[id] = {
    attach: (context, settings) => {
      $(document).ready(function () {
        $('.paragraph--prices .toggle-price-tabs--wrapper', context).each(function () {
          var $wrapper = $(this).closest('.paragraph--prices');
          var $tabs = $(this).find('.toggle-price-tab');

          $tabs.on('click', function () {
            $tabs.removeClass('active');
            $(this).addClass('active');

            if ($(this).hasClass('toggle-price-tab-month')) {
              $wrapper.find('.price-item-month--wrapper').addClass('active');
              $wrapper.find('.price-item-annually--wrapper').removeClass('active');
            } else {
              $wrapper.find('.price-item-annually--wrapper').addClass('active');
              $wrapper.find('.price-item-month--wrapper').removeClass('active');
            }
          });
        });
      });
    }
  };

})(jQuery, Drupal);

